import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "os-chevron.backward",
  "use": "os-chevron.backward-usage",
  "viewBox": "0 0 9.551 16.963",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.551 16.963\" id=\"os-chevron.backward\"><path d=\"M0 8.477q0 .185.068.346.069.161.205.298l7.745 7.568q.263.264.634.264.254 0 .454-.117t.323-.317q.122-.2.122-.454 0-.362-.264-.635l-7.11-6.953 7.11-6.954q.264-.273.264-.634 0-.254-.122-.454T9.106.117Q8.906 0 8.652 0q-.37 0-.634.254L.273 7.832q-.136.137-.205.298Q0 8.29 0 8.477z\" fill=\"rgba(255,255,255,0.85)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol